import { EBlockchainType, Chain } from '@ankr.com/chains-list';

import { useAuth } from 'modules/auth/hooks/useAuth';

export const usePlaceholder = (
  subchain?: Chain,
  hasPrivateAccess?: boolean,
) => {
  const { isLoggedIn } = useAuth();

  if (hasPrivateAccess) {
    return {
      hasPlaceholder: false,
    };
  }

  const isMainnetForPremiumOnly =
    subchain?.type === EBlockchainType.Mainnet &&
    subchain?.isMainnetPremiumOnly;

  const isPremiumOnly = Boolean(subchain?.premiumOnly);

  const isPublic = Boolean(subchain?.isPublic);

  const hasPublicAccess = isPublic || isLoggedIn;

  return {
    hasPlaceholder:
      isPremiumOnly || isMainnetForPremiumOnly || !hasPublicAccess,
    shouldSignIn: !isLoggedIn && !isPremiumOnly && !isPublic,
  };
};
